<template>
  <div class="container questionare-link" @click="scroll">
    <div class="inner">
      <span class="text"><slot></slot></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionareLink",
  props: {
    scrollTo: { type: String, default: "" },
  },
  methods: {
    scroll() {
      let el = document.getElementById(this.$props.scrollTo);
      this.$scrollTo(el, 400, { easing: "ease", offset: -65 });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.questionare-link {
  width: 100%;
  padding: 0 20px;
  > .inner {
    cursor: pointer;
    padding: 20px 0;
    border-top: 1px dotted $secondary;
    border-bottom: 1px dotted $secondary;
    &:hover {
      > :nth-child(n) {
        opacity: 0.7;
      }
    }
    > .text {
      display: block;
      text-align: center;
      padding-bottom: 15px;
      background-image: url("@/assets/images/icons/arrow-down-gray.svg");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-size: 14px 8px;
      @include mq-up(md) {
        font-weight: bold;
      }
    }
  }
}
</style>
